import * as angular from 'angular';
import { IComponentOptions } from 'angular';
import { SchoolPickerAutoCompleteCtrl } from './school-picker-auto-complete.controller';

export const SchoolPickerAutoCompleteComponent: IComponentOptions = {
  template: require('./school-picker-auto-complete.html'),
  bindings: {
    items: '=',
    // name of field in item that contains name to be displayed
    nameField: '@',
    // name of field in item that contains id to be displayed in paranthesis
    idField: '@',
    // placeholder text for input box
    placeholder: '@',
    // reloads controller on click
    reload: '=',
  },
  controller: SchoolPickerAutoCompleteCtrl,
};

angular.module('nv.directives').component('schoolPickerAutoComplete', SchoolPickerAutoCompleteComponent);
